import { makeObservable, observable, action } from "mobx";
import { queryClientMsgInfoList, applyAccessChoose,appPackqueryAuthPackList,switchAuthPack } from "utils/api";

import { Message, Dialog } from "@jdcfe/legao";
import PermissionDetail from "./../components/PermissionDetail";
import qs from "qs";

import useStores from "stores";

import React from "react";


// 订阅管理store
export default class SubscriptionStore {
  list = {};
  isSubscribe = false;
  tableData = [];
  list1 = {};
  tableData1=[];
  tableData2=[];
  history = null;
  constructor() {
    makeObservable(this, {
      list: observable,
      tableData: observable,
      tableData1:observable,
      isSubscribe: observable,
      queryClientMsgInfoList: action,
      // queryClientLimitInfoList:action,
      // queryClientLimitInfoList1:action,
      applyAccessChoose: action,
      
    });
  }
   getHistory = (history) => {
    this.history = history;
  }
  async queryClientMsgInfoList(data) {
   
    const { frameStore } = useStores();

    const res = await queryClientMsgInfoList(data);
    this.list = { ...res.data.result };
    if (
      res.data.success &&
      res.data.result &&
      res.data.result.clientMsgInfoList
    ) {
      this.tableData = res.data.result.clientMsgInfoList.map((item, index) => {
        return {
          name: item.msgName,
          type: item.msgType,
          group: item.msgGroup,
          key: index,
          body: (
            <div className="subscribe-table-item">
              <div
                className="content"
                dangerouslySetInnerHTML={{ __html: item.msgBody }}
              ></div>
            </div>
          ),
          explain: (
            <div className="subscribe-table-item">
              <div
                className="content"
                dangerouslySetInnerHTML={{ __html: item.msgDesc }}
              ></div>
            </div>
          ),
          status:
            item.auditStatus && item.auditStatus === 2
            ?
            (
              <span className="item-status un">
                <i></i>审批中
              </span>
            )
            :
            (item.openStatus === 0 ? (
              <span className="item-status un">
                <i></i>未订阅
              </span>
            ) : (
              <span className="item-status in">
                <i></i>已订阅
              </span>
            )),
          oper: 
          (item.auditStatus && (item.auditStatus === 2))&&(item.openRuleType&&item.openRuleType==2)
          ?
          (<span className="gray">-</span>)
          :
          item.openStatus==1&&item.openRuleType==1? (<span className="subscribe_disabled">默认订阅</span>):
          (
            <a
              className="subscribe_table_link"
              onClick={(e) => {
                // console.log('item', item)
                log('vop_open_pc','vop_open_console_subscribe', item.msgName, item.msgType, frameStore.currentApp.appId);
                e.preventDefault();
                this.confirmDialog(
                  item.msgType,
                  item.openStatus === 0 ? 1 : 0,
                  item.msgName,
                  data,
                  item.msgGroup
                );
              }}
            >
              {item.openStatus === 0 ? "订阅" : "取消订阅"}
            </a>
          ),
        };
      });
    } else {
      this.tableData = [];
    }
  }
  // async queryClientLimitInfoList(data){
  //   const res = await appPackqueryAuthPackList(data);
  //   this.list1 = { ...res.data.result };
  //   if (
  //     res.data.success && res.data.result 
  //   ) {
  //     this.tableData1 = res.data.result.map((item, index) => {
  //       return {
  //         name: item.authPackName,
  //         type: item.authPackDesc,
  //         group: item.auditTypeDesc,
  //         key: item.authPackId,
  //         status:
  //           item.openStateType === 0 ? (
  //             <span className="item-status un">
  //               <i></i>未开通
  //             </span>
  //           ) : item.openStateType === 1?(
  //             <span className="item-status in">
  //               <i></i>已开通
  //             </span>
  //           ):<span className="item-status in">
  //           <i></i>审核中
  //         </span>,
  //         oper: 
  //         item.openStateType && item.openStateType === 1
  //         ?
  //         (
  //           <>
  //             <a
  //             className="subscribe_table_link"
  //             onClick={(e) => {
  //               e.preventDefault();
  //               this.handleDetail(item.authPackId)
  //             }}
  //           >
  //             {"权限详情"}
  //           </a>
  //           <a
  //             className="subscribe_table_link fenge"
  //             onClick={(e) => {
  //               e.preventDefault();
  //               this.handleHelp(
  //                 item.flag,
  //                 item.authPackId,
  //                 item.authPackName,
  //                 item.articleId
  //               )
  //             }}
  //           >
  //             {"对接帮助"}
  //           </a>
  //           </>
          
  //         )
  //         :
  //         (
  //           <a
  //             className="subscribe_table_link"
  //             onClick={(e) => {
  //               e.preventDefault();
           
  //             }}
  //           >
  //             {"开通权限"}
  //           </a>
  //         ),
  //       };
  //     });
  //   } else {
  //     this.tableData1 = [];
  //   }
  // }
  // async queryClientLimitInfoList1(data){
  //   const res = await appPackqueryAuthPackList(data);
  //   console.log(res)
  //   this.list = { ...res.data.result };
  //   if (
  //     res.data.success && res.data.result 
  //   ) {
  //     this.tableData2 =[];
  //     this.tableData2 = res.data.result.map((item, index) => {
  //       return {
  //         name: item.authPackName,
  //         type: item.authPackDesc,
  //         group: item.auditTypeDesc,
  //         key: item.authPackId,
  //         status:
  //           item.openStateType === 0 ? (
  //             <span className="item-status un">
  //               <i></i>未开通
  //             </span>
  //           ) : item.openStateType === 1?(
  //             <span className="item-status in">
  //               <i></i>已开通
  //             </span>
  //           ):<span className="item-status un">
  //           <i></i>审核中
  //         </span>,
  //         oper: 
  //         item.openStateType === 0
  //         ? (
  //           <a
  //             className="subscribe_table_link"
  //             onClick={(e) => {
  //               e.preventDefault();
  //               this.confirmDialog1(item.authPackId,item.authPackName)
  //             }}
  //           >
  //             {"开通权限"}
  //           </a>
  //         )
  //         : item.openStateType == 1 ?
  //         (
  //           <>
  //             <a
  //             className="subscribe_table_link"
  //             onClick={(e) => {
  //               e.preventDefault();
  //               this.handleDetail(item.authPackId)
  //             }}
  //           >
  //             {"权限详情"}
  //           </a>
  //           <a
  //             className="subscribe_table_link fenge"
  //             onClick={(e) => {
  //               e.preventDefault();
  //               this.handleHelp(
  //                 item.flag,
  //                 item.authPackId,
  //                 item.authPackName,
  //                 item.articleId
  //               )
  //             }}
  //           >
  //             {"对接帮助"}
  //           </a>
  //           </>
          
  //         )
  //        :(<span className="gray">- </span> )
  //       };
  //     });
  //   } else {
  //     this.tableData2 = [];
  //   }
  // }
  // handleHelp (flag, authPackId, authPackName, articleId)  {
  //   const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  //   if (flag) {
  //     this.history.push(
  //       `/app/frame/schemelist?appKey=${query.appKey}&authId=${authPackId}&authPackName=${encodeURIComponent(
  //         authPackName
  //       )}`
  //     );
  //   } else {
  //     this.history.push(
  //       `/app/frame/schemedetail?appKey=${query.appKey}&authId=${authPackId}&authPackName=${encodeURIComponent(
  //         authPackName
  //       )}&articleId=${articleId}`
  //     );
  //   }
  // }
  // handleDetail(authPackId){
  //   const urlQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
  //   const { appKey } = urlQuery;
  //   Dialog.confirm({
  //     title: "权限详情",
  //     children: (
  //       <PermissionDetail
  //         authPackId={authPackId}
  //         appKey={appKey}
  //       ></PermissionDetail>
  //     ),
  //     actions: [],
  //     wrapStyle: {
  //       zIndex: 99,
  //     },
  //     className: "app_detail",
  //   });
  // }
  confirmDialog(msgType, applyOpenStatus, msgName, data, msgGroup) {
    let binContact = Dialog.confirm({
      title: applyOpenStatus == 1 ? `确定要订阅${msgName}消息吗？` : `确定要取消订阅${msgName}消息吗？取消后将无法获取到此类消息，请慎重操作！`,
      children: '',
      wrapStyle: {
        zIndex: 99,
      },
      type: 'info',
      actions: [
        {
          text: "确定",
          onClick: () => {
            binContact.close();
            this.applyAccessChoose(msgType, applyOpenStatus, data,msgGroup);
          },
          className: "sure",
          styleType: "primary",
          autoClose: false,
        },
        {
          text: "取消",
          onClick: () => binContact.close(),
          className: "cancel",
          styleType: "",
        },
      ],
      className: "bind_dialog",
    });
  }
  // confirmDialog1(authPackId,authPackName) {
  //   let binContact = Dialog.confirm({
  //     title: "开通权限包",
  //     children: <div className="open_auth_pack">确定开通 <span className="open_auth_pack_name">{authPackName}</span> 吗？</div>,
  //     width:"350",
  //     wrapStyle: {
  //       zIndex: 99,
  //     },
  //     type: 'warn',
  //     actions: [
  //       {
  //         text: "确定",
  //         onClick: () => {
  //           this.openAuthPack(authPackId)
  //           binContact.close();
  //         },
  //         className: "sure",
  //         styleType: "primary",
  //         autoClose: false,
  //       },
  //       {
  //         text: "取消",
  //         onClick: () => binContact.close(),
  //         className: "cancel",
  //         styleType: "",
  //       },
  //     ],
  //     className: "bind_dialog1",
  //   });
  // }
  // async openAuthPack(authPackId){
  //   const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  //   const res = await switchAuthPack({
  //     appKey: query.appKey,
  //     openStateType:1,
  //     authPackId:authPackId
  //   });
  //   const flag =res.data.success ;
  //   if(flag){
  //     Message.showMsg({
  //       showIcon: true,
  //       type:  "success" ,
  //       description: "成功",
  //       autohide: true,
  //       closable: false,
  //       onClose: () => {
  //         this.queryClientLimitInfoList1({appKey: query.appKey,openStateType:0})
  //       },
  //     });
     
  //   }else{
  //     Message.showMsg({
  //       showIcon: true,
  //       type:  "warn" ,
  //       description: "失败",
  //       autohide: true,
  //       closable: false,
  //       onClose: () => {
  //       },
  //     });
  //   }
  // }

  async applyAccessChoose(msgType, applyOpenStatus, data,msgGroup) {
    log('vop_open_pc', 'vop_open_console_applyAccess', msgGroup,msgType,applyOpenStatus,window['appsMap'][data.appKey].clientId);//缺少clientId
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    const res = await applyAccessChoose({
      appKey: query.appKey,
      chooseMsgTypeReqList: [
        {
          msgType,
          applyOpenStatus,
        },
      ],
    });
    const flag =
      res.data.success 
      // &&
      // res.data.result.chooseMsgTypeRespList[0].currentOpenStatus ===
      //   applyOpenStatus;
    const mess = flag
      ? "成功"
      : res.data.result.chooseMsgTypeRespList[0].refuseCause || "失败";
    Message.showMsg({
      showIcon: true,
      type: flag ? "success" : "wrong",
      description: mess,
      autohide: true,
      closable: false,
      onClose: () => {},
    });
    flag && this.queryClientMsgInfoList(data);
  }
}
